/* eslint-disable */
import * as types from "../../Types/Masters";

export const MasterAction = (type: any, payload: any) => {
  switch (type) {
    case types.SET_GENDER_DETAILS:
      return {
        type: types.SET_GENDER_DETAILS,
        payload
      };
    case types.SET_RELATIONSHIP_DETAILS:
      return {
        type: types.SET_RELATIONSHIP_DETAILS,
        payload
      };
    case types.SET_EDUCATION_DETAILS:
      return {
        type: types.SET_EDUCATION_DETAILS,
        payload
      };
    case types.SET_OCCUPATION_DETAILS:
      return {
        type: types.SET_OCCUPATION_DETAILS,
        payload
      };
    case types.SET_ASSIGNMENT_OCCUPATION_DETAILS:
      return {
        type: types.SET_ASSIGNMENT_OCCUPATION_DETAILS,
        payload
      };
    case types.SET_SALUTATION_DETAILS:
      return {
        type: types.SET_SALUTATION_DETAILS,
        payload
      };
    case types.SET_MARITAL_STATUS_DETAILS:
      return {
        type: types.SET_MARITAL_STATUS_DETAILS,
        payload
      };
    case types.SET_SUB_OCCUPATION_DETAILS:
      return {
        type: types.SET_SUB_OCCUPATION_DETAILS,
        payload
      };
    case types.SET_INSURANCE_COMPANY:
      return {
        type: types.SET_INSURANCE_COMPANY,
        payload
      };
    case types.SET_POLICY_STATUS:
      return {
        type: types.SET_POLICY_STATUS,
        payload
      };
    case types.SET_RULE_ENGINE:
      return {
        type: types.SET_RULE_ENGINE,
        payload
      };
    case types.SET_JOINT_RELATIONSHIP_DETAILS:
      return {
        type: types.SET_JOINT_RELATIONSHIP_DETAILS,
        payload
      };
    case types.SET_PRODUCT:
      return {
        type: types.SET_PRODUCT,
        payload
      };
    case types.SET_PRODUCT_PARTNER:
      return {
        type: types.SET_PRODUCT_PARTNER,
        payload
      };
    case types.SET_CHANNEL:
      return {
        type: types.SET_CHANNEL,
        payload
      };
    case types.SET_MEF_JOURNEY_SCHEMA:
      return {
        type: types.SET_MEF_JOURNEY_SCHEMA,
        payload
      };
    case types.SET_LOAN_VALUES:
      return {
        type: types.SET_LOAN_VALUES,
        payload
      };
    default:
      return {
        type: "DEFAULT_ACTION",
        payload
      };
  }
};

export const setQuestionnaire = (payload: Record<string, any>) => {
  return {
    type: types.SET_QUESTIONNAIRE,
    payload
  };
};
